import { FormControlLabel, Grid, Switch } from "@mui/material";
import { FastField } from "formik";
import {
  MySelect,
  MySelectTime,
  MyTextField,
  MyTextFieldArea,
  MyTextFieldUploadFile,
  UploadMultiFile
} from "../../Lib/componentLibrarys";
import Api from "../../../api2";
import { useState } from "react";
import { isEmpty } from "lodash";

export const FormNhap = ({ values, errors, setFieldValue }) => {
  const [phuongXaList, setPhuongXaList] = useState([]);
  const [quanHuyenList, setQuanHuyenList] = useState([]);
  const [tinhThanhList, setTinhThanhList] = useState([]);

  const getApiListDvhc = (cap, madvhc, setData) => {
    new Api()
      .GetListDvhc({ cap: cap, madvhc: madvhc })
      .then(data => {
        if (data.code === 200) {
          setData(data?.data?.result);
        }
      })
      .catch(err => {})
      .finally(() => {});
  };
  return (
    <div>
      <Grid container spacing={1} style={{ marginTop: "0px" }}>
        <Grid item xs={6}>
          <FastField name="tenCoSoPhanPhoi">
            {({ field }) => (
              <MyTextField
                required
                label="Tên cơ sở phân phối:"
                placeholder="Nhập..."
                errors={errors?.tenCoSoPhanPhoi}
                helperText={errors?.tenCoSoPhanPhoi}
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <FastField name="maSoThue">
            {({ field }) => (
              <MyTextField
                required
                label="Mã số thuế:"
                placeholder="Nhập..."
                errors={errors?.maSoThue}
                helperText={errors?.maSoThue}
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <FastField name="nguoiDaiDien">
            {({ field }) => (
              <MyTextField
                required
                label="Người đại diện:"
                placeholder="Nhập..."
                errors={errors?.nguoiDaiDien}
                helperText={errors?.nguoiDaiDien}
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <FastField name="cccd">
            {({ field }) => (
              <MyTextField
                required
                label="CCCD:"
                placeholder="Nhập..."
                errors={errors?.cccd}
                helperText={errors?.cccd}
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <FastField name="dienThoai">
            {({ field }) => (
              <MyTextField
                label="Điện thoại:"
                placeholder="Nhập..."
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <FastField name="email">
            {({ field }) => (
              <MyTextField label="Email:" placeholder="Nhập..." {...field} />
            )}
          </FastField>
        </Grid>
        <Grid item xs={12}>
          <FastField name="website">
            {({ field }) => (
              <MyTextField label="Website:" placeholder="Nhập..." {...field} />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <MySelect
            label="Tỉnh thành:"
            placeholder="Chọn..."
            value={values?.tinhThanh}
            options={tinhThanhList}
            name="tenDVHC"
            onChange={(event, value) => {
              setFieldValue(`tinhThanh`, value);
              setFieldValue(`quanHuyen`, null);
              setFieldValue(`phuongXa`, null);
            }}
            onOpen={() => {
              isEmpty(tinhThanhList) && getApiListDvhc(1, "", setTinhThanhList);
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <MySelect
            label="Quận huyện:"
            placeholder="Chọn..."
            value={values?.quanHuyen}
            options={quanHuyenList || []}
            name="tenDVHC"
            onChange={(event, value) => {
              setFieldValue(`quanHuyen`, value);
              setFieldValue(`phuongXa`, null);
            }}
            onOpen={() => {
              values?.tinhThanh?.maTinh &&
                getApiListDvhc(2, values.tinhThanh.maTinh, setQuanHuyenList);
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <MySelect
            label="Phường xã:"
            placeholder="Chọn..."
            value={values?.phuongXa}
            options={phuongXaList || []}
            name="tenDVHC"
            onChange={(event, value) => {
              setFieldValue(`phuongXa`, value);
            }}
            onOpen={() => {
              values?.quanHuyen?.maHuyen &&
                getApiListDvhc(3, values.quanHuyen.maHuyen, setPhuongXaList);
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <FastField name="diaChi">
            {({ field }) => (
              <MyTextField label="Địa chỉ:" placeholder="Nhập..." {...field} />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <MySelectTime
            label="Ngày hoạt động:"
            placeholder="Chọn..."
            value={values?.ngayHoatDong}
            onChange={value => {
              setFieldValue(`ngayHoatDong`, value);
            }}
            width="100%"
          />
        </Grid>
        <Grid item xs={6}>
          <FormControlLabel
            style={{ marginLeft: 0.5, alignItems: "center", marginTop: 20 }}
            control={
              <Switch
                checked={values?.tinhTrangHoatDong}
                onChange={(event, value) => {
                  setFieldValue("tinhTrangHoatDong", value);
                }}
              />
            }
            label="Tình trạng hoạt động"
          />
        </Grid>
        <Grid item xs={12}>
          <FastField name="thongTinMoTa">
            {({ field }) => (
              <MyTextFieldArea
                label="Mô tả:"
                placeholder="Nhập..."
                maxRows={3}
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={12}>
          <FastField name="ghiChu">
            {({ field }) => (
              <MyTextFieldArea
                label="Ghi chú:"
                placeholder="Nhập..."
                maxRows={3}
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={12} className="fileGiayChungNhan">
          <UploadMultiFile
            multi={false}
            title="Tệp đính kèm:"
            file={values?.fileImages || []}
            handleChangeFile={values => setFieldValue(`fileImages`, values)}
            checkSave={false}
          />
        </Grid>
      </Grid>
    </div>
  );
};
